import { formatHanAmount } from "#format-han";
import { formatHanMiles } from "#han-miles";

/** What one reward holds; each field is 0 when it holds none of that. */
export interface HanReward {
  /** Dragons (龙): each carries the learner anywhere unlocked, instantly. */
  dragons: number;
  han: number;
  hanMiles: number;
  /** Extra Han every review earns for the rest of the local day the reward is claimed. */
  reviewBonusHan: number;
}

export const EMPTY_HAN_REWARD: HanReward = { dragons: 0, han: 0, hanMiles: 0, reviewBonusHan: 0 };

/** What a reward holds, in words: `10 Han`, `1,000 HanMiles and 1 dragon`, … */
export function describeHanReward(reward: Partial<HanReward>): string {
  const { dragons = 0, han = 0, hanMiles = 0, reviewBonusHan = 0 } = reward;
  const parts: string[] = [];
  if (han > 0) {
    parts.push(`${formatHanAmount(han)} Han`);
  }
  if (hanMiles > 0) {
    parts.push(formatHanMiles(hanMiles));
  }
  if (reviewBonusHan > 0) {
    parts.push(`${formatHanAmount(reviewBonusHan)} bonus Han per review all day`);
  }
  if (dragons > 0) {
    parts.push(dragons === 1 ? "1 dragon" : `${formatHanAmount(dragons)} dragons`);
  }
  return parts.length === 0 ? "nothing" : parts.join(" and ");
}
